export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "es": {
        "model": {
          "crop_har_package": {
            "_self": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Paquete"])},
            "name": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nombre"])},
            "quantity": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cantidad"])},
            "crop_id": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cultivo"])}
          }
        }
      },
      "en": {
        "model": {
          "crop_har_package": {
            "_self": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Package"])},
            "name": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Name"])},
            "quantity": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Quantity"])},
            "crop_id": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Crop"])}
          }
        }
      }
    }
  })
}